/**
 * 获取当前设备类型，用于上报后端（最近一次设备）
 * @returns {'ios'|'android'|''}
 */
export function getDeviceType() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return '';
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return '';
}
